import API, { graphqlOperation } from "@aws-amplify/api";
import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";
import { makeGraphQLRequest } from "..";

const createAppConfig = async (object) => {
  try {
    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.createAppConfig, { input: object })
    );
    return response.data.createAppConfig;
  } catch (error) {
    console.error("Error creating AppConfig:", error);
    throw error;
  }
};

const updateAppConfig = async (id, args) => {
  try {
    // First, fetch the current version of the AppConfig
    const getAppConfigResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getAppConfig, { id })
    );
    const currentAppConfig = getAppConfigResponse.data.getAppConfig;

    // Prepare the update input
    const updateInput = { id, _version: currentAppConfig._version };
    args.forEach((arg) => {
      updateInput[arg.property] = arg.value;
    });

    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.updateAppConfig, { input: updateInput })
    );
    return response.data.updateAppConfig;
  } catch (error) {
    console.error("Error updating AppConfig:", error);
    throw error;
  }
};

const deleteAppConfig = async (id) => {
  try {
    // First, fetch the current version of the AppConfig
    const getAppConfigResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getAppConfig, { id })
    );
    const currentAppConfig = getAppConfigResponse.data.getAppConfig;

    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.deleteAppConfig, {
        input: { id, _version: currentAppConfig._version },
      })
    );
    return response.data.deleteAppConfig;
  } catch (error) {
    console.error("Error deleting AppConfig:", error);
    throw error;
  }
};

const listAppConfig = async () => {
  try {
    const response = await makeGraphQLRequest(
      graphqlOperation(queries.listAppConfigs)
    );
    return response.data.listAppConfigs.items;
  } catch (error) {
    console.error("Error listing AppConfigs:", error);
    throw error;
  }
};

export default {
  createAppConfig,
  updateAppConfig,
  deleteAppConfig,
  listAppConfig,
};
